export const messages = {
  en: {
    privilege: {
      title: 'Privilege Management',
      group: 'Group',
      menu: 'Menu',
      privilege: 'Privilege',
      selectAll: 'Select All',
      deselectAll: 'Deselect All',
      saveSuccess: 'Save privilege successfully',
      deleteSuccess: 'Delete privilege successfully'
    }
  },
  zh: {
    privilege: {
      title: '权限管理',
      group: '分组',
      menu: '菜单',
      privilege: '权限',
      selectAll: '全选',
      deselectAll: '取消全选',
      saveSuccess: '保存权限成功',
      deleteSuccess: '删除权限成功'
    }
  }
}